import script from "./ActivationsEventsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationsEventsTable.vue?vue&type=script&setup=true&lang=js"

import "./ActivationsEventsTable.vue?vue&type=style&index=0&id=6baf1475&lang=scss&scoped=true"
script.__scopeId = "data-v-6baf1475"

export default script